module.exports = __webpack_public_path__ + "static/OneDotCd-Bold.5d4912b8.eot";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDotCd-Bold.eot
// module id = 738
// module chunks = 114276838955818